// @flow
// after 15 minutes of inactivity, the user's session expires
// we warn them of this after 14 minutes to give them a minute to interact
// with the app and extend their session.
import { isNativeApp } from './venice'

let signoutTimer
let warningTimer
let onWarning

function init(options) {
  onWarning = options.onWarning
  if (isNativeApp) {
    startNativeAuthTimer()
  } else {
    startWebAuthTimer()
  }
}

function startNativeAuthTimer() {
  const TIMEOUT = 15.02 * 60 * 1000 // 15 minutes and 1.2 seconds
  setTimeout(() => {
    window.venice.reAuth()
  }, TIMEOUT)
}

function startWebAuthTimer() {
  const TIMEOUT = 14 * 60 * 1000 // 14 minutes
  warningTimer = setTimeout(() => {
    onWarning()
    signoutTimer = setTimeout(() => {
      window.location.assign('/signin')
    }, 60 * 1000) // 1 minute
  }, TIMEOUT)
}

function onSessionExtended() {
  clearTimeout(signoutTimer)
  clearTimeout(warningTimer)
  startWebAuthTimer()
}

export { init, onSessionExtended }
